var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.95 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#A7A7A7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,40a3.7,3.7,0,0,1-3.7-3.7h7.4A3.7,3.7,0,0,1,20,40Zm14.1-5.58H5.88a1.86,1.86,0,0,1-1.3-3.19L7,28.84V17.67A13,13,0,0,1,17.21,5V2.79a2.79,2.79,0,1,1,5.58,0V5A13,13,0,0,1,33,17.67V28.84l2.4,2.4a1.86,1.86,0,0,1,0,2.63,1.88,1.88,0,0,1-1.34.55Zm-16-11.16V27h3.72V23.26ZM20,12.09A1.87,1.87,0,0,0,18.14,14v3.72a1.86,1.86,0,0,0,3.72,0V14A1.86,1.86,0,0,0,20,12.09Z",
    transform: "translate(-4.02)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity_icon.1e8dc0af59bb1d53cf4a3d1ad2f030f6.svg";
export { ForwardRef as ReactComponent };